import httpUtil from "@/utils/httpUtil";
/** 获取列表 */
export function fetchDealerBlockList(params) {
	return httpUtil.get("/dealerBlockLog", params)
}


export function fetchAddDealerBlock(params) {
	return httpUtil.post("/dealerBlockLog", params)
}

export function fetchDelDealerBlock(params) {
	return httpUtil.post("/dealerBlockLog/delete", params)
}

export function fetchDealerLotNumber(params) {
	return httpUtil.get("/crk/app/lotNumberList", params)
}
